import { module } from 'modujs';
import { lerp } from '../utils/maths';
import { transform } from '../utils/transform';

export default class extends module {
    init() {

        if (window.isMobile) return;

        this.hasMoved = false;

        this.mouse = {
            x: 0,
            y: 0,
            lerpedX: 0,
            lerpedY: 0
        }

        this.animate();

        this.bindMousemove = this.mousemove.bind(this);
        window.addEventListener('mousemove', this.bindMousemove);

        this.bindEnter = this.hover.bind(this);
        this.bindLeave = this.leave.bind(this);

        this.hoverElements = document.querySelectorAll('a, button:not([type="submit"]), .js-hover, .js-text-link, .js-hover-play, .js-hover-next, .js-hover-prev');
        this.hoverElements.forEach(el => {
            el.addEventListener('mouseenter', this.bindEnter);
            el.addEventListener('mouseleave', this.bindLeave);
        });
    }

    animate() {
        this.raf = requestAnimationFrame(() => this.animate());

        this.mouse.lerpedX = lerp(this.mouse.lerpedX, this.mouse.x, 0.2);
        this.mouse.lerpedY = lerp(this.mouse.lerpedY, this.mouse.y, 0.2);

        const rotation = (this.mouse.x - this.mouse.lerpedX) * 0.03;

        transform(this.el, `translate3d(${this.mouse.lerpedX}px,${this.mouse.lerpedY}px,0) rotate(${rotation}deg)`)
    }

    mousemove(e) {

        if (!this.hasMoved) {
            this.hasMoved = true;
            this.el.classList.add('has-moved');
        }

        this.mouse.x = e.clientX;
        this.mouse.y = e.clientY;

    }

    hover(e) {
        let el = e.currentTarget;

        if (this.delayedCall !== undefined) {
            this.delayedCall.kill();
        }

        this.el.classList.remove('has-hover-callback');
        this.el.classList.remove('has-hover-play-callback');
        this.el.classList.remove('has-hover-next-callback');
        this.el.classList.remove('has-hover-prev-callback');

        if (el.classList.contains('js-hover-play')) {
            this.el.classList.add('has-hover-play');
            this.el.classList.add('has-hover-play-callback');
        }
        if (el.classList.contains('js-hover-prev')) {
            this.el.classList.add('has-hover-prev');
            this.el.classList.add('has-hover-prev-callback');
        }
        if (el.classList.contains('js-hover-next')) {
            this.el.classList.add('has-hover-next');
            this.el.classList.add('has-hover-next-callback');
        }

        if (el.classList.contains('js-text-link')) {
            this.el.classList.add('has-hover-text');
        }

        this.el.classList.add('has-hover');
        this.el.classList.add('has-hover-callback');
    }

    leave(e) {

        let el = e.currentTarget;

        if (el.classList.contains('js-hover-play')) {
            this.el.classList.remove('has-hover-play');
        }
        if (el.classList.contains('js-hover-prev')) {
            this.el.classList.remove('has-hover-prev');
        }
        if (el.classList.contains('js-hover-next')) {
            this.el.classList.remove('has-hover-next');
        }

        if (el.classList.contains('js-text-link')) {
            this.el.classList.remove('has-hover-text');
        }

        this.el.classList.remove('has-hover');

        // callback
        this.delayedCall = gsap.delayedCall(0.6, () => {
            this.el.classList.remove('has-hover-callback');

            if (el.classList.contains('js-hover-play')) {
                this.el.classList.remove('has-hover-play-callback');
            }
            if (el.classList.contains('js-hover-prev')) {
                this.el.classList.remove('has-hover-prev-callback');
            }
            if (el.classList.contains('js-hover-next')) {
                this.el.classList.remove('has-hover-next-callback');
            }

        });
    }

    destroy() {
        if (window.isMobile) return;

        window.removeEventListener('mousemove', this.bindmousemove);

        this.hoverElements.forEach(el => {
            el.removeEventListener('mouseenter', this.bindEnter);
            el.removeEventListener('mouseleave', this.bindLeave);
        });

        this.el.classList.remove('has-hover-play', 'has-hover-prev', 'has-hover-next', 'has-hover-text');

        cancelAnimationFrame(this.raf);

    }
}
